import React from 'react';
import './Rate.css';

class Rate extends React.Component {
    render() {
        return (
            <div className="main_info">
                <div className="main_info-title">
                    <div>
                        <h2>Курс валют на <span>{this.props.rates.date}</span></h2>
                    </div>
                    <div>
                        <p>
                            <img src="https://i0.wp.com/itc.ua/wp-content/uploads/2015/11/PrivatBank.jpg?fit=671%2C362&quality=100&strip=all&ssl=1" alt=""/>
                        </p>
                    </div>
                </div>
                <div className="main_info-rates">
                    {this.props.rates.div}
                </div>
            </div >
        )
    }
}

export default Rate;




